import {
  ClipboardCheckIcon,
  BriefcaseIcon,
  CalendarIcon,
  NewspaperIcon,
  UserIcon,
  PencilIcon,
  TicketIcon,
  DocumentIcon,
  AcademicCapIcon,
  BookOpenIcon,
} from "@heroicons/react/outline"

export const profil = [
  {
    id: 11,
    name: "Min Side",
    href: "/app",
    description: "Personlig informasjon",
    icon: UserIcon,
  },
  // {
  //   name: "Mine samtykker",
  //   href: "/Profil/samtykker",
  //   description: "Oversikt over mine samtykker",
  //   icon: CheckIcon,
  // },
  {
    id: 12,
    name: "Arbeidsforhold",
    href: "/app/profil/arbeidsforhold/",
    description: "",
    icon: BriefcaseIcon,
  },
  {
    id: 13,
    name: "Utdanning",
    href: "/app/profil/utdanning/",
    description: "",
    icon: AcademicCapIcon,
  },
  {
    id: 15,
    name: "Sertifisering",
    href: "/app/profil/sertifisering/",
    description: "",
    icon: DocumentIcon,
  },
  {
    id: 14,
    name: "Tidsskrift",
    href: "/app/profil/tidsskrift",
    description: "",
    icon: NewspaperIcon,
  },
]

export const medlem = [
  {
    id: 21,
    name: "Bli medlem",
    href: "/app/medlemskap/nymedlemskap",
    description: "Meld meg inn",
    icon: PencilIcon,
  },
  {
    id: 22,
    name: "Mine medlemskap",
    href: "/app/medlemskap/minemedlemskap",
    description: "Meld meg inn",
    icon: DocumentIcon,
  },
  {
    id: 23,
    name: "Endre medlemskap",
    href: "/app/medlemskap/endremedlemskap",
    description: "Endre medleskap",
  },
  // {
  //   id: 24,
  //   name: "Forsikringsbevis",
  //   href: "#",
  //   description: "",
  //   icon: ClipboardCheckIcon,
  // },
]

export const kurs = [
  // { name: "Påmelding", href: "#", icon: PencilIcon },
  {
    id: 31,
    name: "Mine kurs",
    href: "/app/kurs/minekurs",
    icon: DocumentIcon,
  },
  {
    id: 32,
    name: "Kurskalender",
    href: "/app/kurs/kurskalender",
    icon: CalendarIcon,
  },
  {
    id: 33,
    name: "Spesialistutdanning",
    href: "/app/kurs/specialityeducation/utdanning",
    icon: BookOpenIcon,
  },
  {
    id: 34,
    name: "Kursadministrasjon",
    href: "/app/kurs/administrasjon",
    icon: BookOpenIcon,
  },
  {
    id: 35,
    name: "Kursleverandør",
    href: "/app/kurs/kursleverandor",
    icon: BookOpenIcon,
  },
]

export const dialog = [
  {
    id: 36,
    name: "Ny sak",
    href: "/app/dialog/nysak",
    description: "ny sak",
    icon: TicketIcon,
  },
  {
    id: 37,
    name: "Mine saker",
    href: "/app/dialog/minesaker",
    description: "Mine saker",
    icon: TicketIcon,
  },
  {
    id: 38,
    name: "Mine meldinger",
    href: "/app/dialog/minemeldinger",
    description: "Mine meldinger",
    icon: TicketIcon,
  },
  {
    id: 40,
    name: "Dokumenter",
    href: "/app/dialog/dokumenter",
    description: "Mine dokumenter",
    icon: BookOpenIcon,
  },
  {
    id: 39,
    name: "Mine utlegg",
    href: "/app/dialog/mineutlegg",
    description: "Mine utlegg",
    icon: TicketIcon,
  },
]
